<template>
    <el-drawer :visible.sync="visible" direction="rtl" size="680px" append-to-body
               :title="title" :with-header="false" custom-class="details-drawer-panel"
               @closed="$emit('closed')">
        <div class="details-drawer-shell">
            <header class="details-drawer-header">
                <div class="details-drawer-actions">
                    <el-button class="details-drawer-delete" :loading="deleting" :disabled="deleteDisabled"
                               @click="$emit('delete')">{{$t('common.delete')}}</el-button>
                    <el-button class="details-drawer-edit" :disabled="deleting" @click="$emit('edit')">{{$t('common.edit')}}</el-button>
                    <button class="details-drawer-close" type="button" :aria-label="$t('common.close')" @click="close">
                        <i class="el-icon-close" aria-hidden="true"></i>
                    </button>
                </div>
            </header>
            <div class="details-drawer-scroll"><slot></slot></div>
        </div>
    </el-drawer>
</template>

<script>
    export default {
        name: 'DetailsDrawer',
        props: {
            title: {type: String, required: true},
            deleting: Boolean,
            deleteDisabled: Boolean
        },
        data() {
            return {visible: false};
        },
        methods: {
            close() {
                this.visible = false;
            }
        },
        mounted() {
            this.visible = true;
        }
    }
</script>

<style src="../../assets/detailsDrawer.css"></style>
